module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "300px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请输入[姓名|手机号]"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.page.criteria),
      callback: function($$v) {
        _vm.$set(_vm.page, "criteria", $$v)
      },
      expression: "page.criteria"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.query
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.datalist,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "cnee",
      "label": "收货人",
      "width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机",
      "width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "area",
      "label": "所在地区",
      "width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "addr",
      "label": "详细地址",
      "width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.editAddr(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteAddr(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticClass: "pull-right clearfix",
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.totalsize,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.formtitle,
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "subData",
    staticStyle: {
      "margin": "20px"
    },
    attrs: {
      "rules": _vm.rules,
      "model": _vm.subData,
      "label-width": "100px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收货人",
      "prop": "cnee"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入收货人"
    },
    model: {
      value: (_vm.subData.cnee),
      callback: function($$v) {
        _vm.$set(_vm.subData, "cnee", $$v)
      },
      expression: "subData.cnee"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机",
      "prop": "phone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入手机"
    },
    model: {
      value: (_vm.subData.phone),
      callback: function($$v) {
        _vm.$set(_vm.subData, "phone", $$v)
      },
      expression: "subData.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所在地区",
      "prop": "area"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入所在地区"
    },
    model: {
      value: (_vm.subData.area),
      callback: function($$v) {
        _vm.$set(_vm.subData, "area", $$v)
      },
      expression: "subData.area"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详细地址",
      "prop": "addr"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入详细地址"
    },
    model: {
      value: (_vm.subData.addr),
      callback: function($$v) {
        _vm.$set(_vm.subData, "addr", $$v)
      },
      expression: "subData.addr"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.saveAddr('subData')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f688486"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/personalinfo/customerAddrList.vue
// module id = 1211
// module chunks = 10